export var HttpMethod;
(function (HttpMethod) {
    HttpMethod["GET"] = "GET";
    HttpMethod["HEAD"] = "HEAD";
    HttpMethod["POST"] = "POST";
    HttpMethod["PUT"] = "PUT";
    HttpMethod["DELETE"] = "DELETE";
    HttpMethod["CONNECT"] = "CONNECT";
    HttpMethod["OPTIONS"] = "OPTIONS";
    HttpMethod["TRACE"] = "TRACE";
    HttpMethod["PATCH"] = "PATCH";
    HttpMethod["QUERY"] = "QUERY";
})(HttpMethod || (HttpMethod = {}));
function ensureAbsoluteUrl(url) {
    if (url.startsWith("http://") || url.startsWith("https://")) {
        return url;
    }
    if (typeof window !== 'undefined' && window.location?.origin) {
        return window.location.origin + url;
    }
    const base = 'http://localhost';
    return url.startsWith('/') ? base + url : base + '/' + url;
}
export class RequestContext {
    httpMethod;
    headers = {};
    body = undefined;
    url;
    signal;
    constructor(url, httpMethod, signal) {
        this.httpMethod = httpMethod;
        this.url = new URL(ensureAbsoluteUrl(url));
        this.signal = signal;
    }
    getUrl() {
        return this.url.toString().endsWith("/") ?
            this.url.toString().slice(0, -1)
            : this.url.toString();
    }
    setUrl(url) {
        this.url = new URL(ensureAbsoluteUrl(url));
    }
    setBody(body) {
        this.body = body;
    }
    getHttpMethod() {
        return this.httpMethod;
    }
    getHeaders() {
        return this.headers;
    }
    getBody() {
        return this.body;
    }
    setQueryParam(name, value) {
        this.url.searchParams.set(name, value);
    }
    isIdempotent() {
        return this.httpMethod === 'GET' || this.httpMethod === 'HEAD' || this.httpMethod === 'QUERY';
    }
    addCookie(name, value) {
        if (!this.headers["Cookie"]) {
            this.headers["Cookie"] = "";
        }
        this.headers["Cookie"] += name + "=" + value + "; ";
    }
    setHeaderParam(key, value) {
        this.headers[key] = value;
    }
}
export class ResponseContext {
    httpStatusCode;
    headers;
    body;
    constructor(httpStatusCode, headers, body) {
        this.httpStatusCode = httpStatusCode;
        this.headers = headers;
        this.body = body;
    }
    getParsedHeader(headerName) {
        const result = {};
        if (!this.headers[headerName]) {
            return result;
        }
        const parameters = this.headers[headerName].split(";");
        for (const parameter of parameters) {
            let [key, value] = parameter.split("=", 2);
            key = key.toLowerCase().trim();
            if (value === undefined) {
                result[""] = key;
            }
            else {
                value = value.trim();
                if (value.startsWith('"') && value.endsWith('"')) {
                    value = value.substring(1, value.length - 1);
                }
                result[key] = value;
            }
        }
        return result;
    }
    async getBodyAsFile() {
        const data = await this.body.binary();
        const fileName = this.getParsedHeader("content-disposition")["filename"] || "";
        const contentType = this.headers["content-type"] || "";
        try {
            return new File([data], fileName, { type: contentType });
        }
        catch (error) {
            return Object.assign(data, {
                name: fileName,
                type: contentType
            });
        }
    }
    getBodyAsAny() {
        try {
            return this.body.text();
        }
        catch { }
        try {
            return this.body.binary();
        }
        catch { }
        return Promise.resolve(undefined);
    }
}
export class HttpInfo extends ResponseContext {
    httpStatusCode;
    headers;
    body;
    data;
    constructor(httpStatusCode, headers, body, data) {
        super(httpStatusCode, headers, body);
        this.httpStatusCode = httpStatusCode;
        this.headers = headers;
        this.body = body;
        this.data = data;
    }
}
